module.exports = __webpack_public_path__ + "static/media/github-wagyu-key-gen-screenshot.f39f808f.png";